export const iconFontAwesomeWritingPaperclip = (
	<i className="fa-solid fa-paperclip"></i>
);
